import {PerformanceInteractionTypesEnum} from './interactionPerformanceTypes';

/*
 * Constants.
 */

export const interactionSampleRates: {[key in PerformanceInteractionTypesEnum]: number} = {
  [PerformanceInteractionTypesEnum.CELLS_FETCH]: 1,
  [PerformanceInteractionTypesEnum.CELLS_SCROLL]: 0.001,
  [PerformanceInteractionTypesEnum.VIEWER_FETCH]: 1,
  [PerformanceInteractionTypesEnum.VIEWER_SCROLL]: 0.001,
  [PerformanceInteractionTypesEnum.TEXT_INPUT]: 0.001,
  [PerformanceInteractionTypesEnum.MESSAGE_REPLY]: 0.1,
  [PerformanceInteractionTypesEnum.SEND_MESSAGE]: 0.1,
  [PerformanceInteractionTypesEnum.SEND_COMMENT]: 0.1,
  [PerformanceInteractionTypesEnum.CELLS_SWIPE_ACTION]: 0.03,
  [PerformanceInteractionTypesEnum.OVERLAY_DISPLAY]: 0.03,
  [PerformanceInteractionTypesEnum.CONVERSATION_ACTION]: 0.03,
  [PerformanceInteractionTypesEnum.TEST]: 1,
};
